function IsNumeric(input) {
  var RE =
    /^-?(0|INF|(0[1-7][0-7]*)|(0x[0-9a-fA-F]+)|((0|[1-9][0-9]*|(?=[\.,]))([\.,][0-9]+)?([eE]-?\d+)?))$/;
  return RE.test(input);
}

module.exports = {
  emailValidate: (value) => {
    const isValid = new RegExp(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    ).test(value);
    return isValid;
  },
  phoneValidate: (value) => {
    const isValid = new RegExp(/((0)(\d{8,9}$))/).test(value);
    return isValid;
  },
  mobilePhoneValidate: (value) => {
    const isValid = new RegExp(/^(0[689]{1})+([0-9]{8})+$/).test(value);
    return isValid;
  },
  citizenValidate: (value) => {
    if (!IsNumeric(value)) return false;
    if (value.substring(0, 1) == 0) return false;
    if (value.length != 13) return false;
    let i = 0;
    let sum;
    for (sum = 0; i < 12; i++) {
      sum += parseFloat(value.charAt(i)) * (13 - i);
    }
    if ((11 - (sum % 11)) % 10 != parseFloat(value.charAt(12))) return false;
    return true;
  },
  postCodeValidate: (value) => {
    if (!IsNumeric(value)) return false;
    if (value.substring(0, 1) == 0) return false;
    if (value.length != 5) return false;
    return true;
  },
  expiryValidate: (value) => {
    const currentDate = new Date();
    if (currentDate > value) return false;
    return true;
  },
  textOnlyValidate: (value) => {
    const isValid = new RegExp(/^[a-zA-Zก-๏\s]+$/).test(value);
    return isValid;
  },
  objectMinCountValidate: (value, min) => {
    const isValid = Object.keys(value).length > min ? true : false;
    return isValid;
  },
};
